import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getOrigin } from '@rover/shared/js/utils/getFullUrl';

/**
 * Hook to get the current API base URL
 * @param defaultUrl - Optional default URL to use if getOrigin() returns undefined
 * @returns UseQueryResult containing the base URL string
 */
export const useApiBase = (defaultUrl?: string): UseQueryResult<string> => {
  return useQuery({
    queryKey: ['getAPIBase'],
    queryFn: () => {
      return getOrigin() || defaultUrl;
    },
  });
};

/**
 * Hook that returns a function to convert relative URLs to absolute URLs
 * @returns Function that takes a relative URL and returns an absolute URL
 */
export const useAbsoluteUrl = (): ((url: string) => string) => {
  const { data: baseUrl } = useApiBase();

  const asAbsoluteUrl = (url: string): string => {
    return `${baseUrl}${url}`;
  };

  return asAbsoluteUrl;
};
